<template>
  <div class="template-padding">
    <div class="row">
      <div class="col col-sm-8">
        <h3 class="font-weight-bolder">
          Training Course List
        </h3>
      </div>
      <div class="col col-sm-4">
        <router-link
          to="/trainingSchedule"
          tag="button"
          class="btn btn-sm btn-outline-info font-weight-bolder mr-2 float-right"
        >
          <span><i class="fas fa-calendar" /></span>
          View Calendar
        </router-link>
      </div>
    </div>

    <hr class="hr-color">


    <div class="row">
      <div class="col-sm-1 text-right pr-0">
        <label
          for="course"
          class="col-form-label form-label font-weight-bolder text-right"
        >
          <h6><strong>Search:</strong></h6>
        </label>
      </div>

      <div class="col col-sm-6">
        <form
          class="form-row input-group"
          @submit.prevent="searchSchedule"
        >
          <input
            type="text"
            id="course"
            class="form-control form-control-xs col col-sm-6 input-group-text input-group-append rounded-left"
            placeholder="Type Training Course Here"
            v-model="params.course"
          >

          <input
            type="date"
            class="form-control form-control-xs col col-sm-4 input-group-text input-group-append"
            title="Date From"
            v-model="params.dateFrom"
          >

          <input
            type="date"
            class="form-control form-control-xs col col-sm-4 input-group-text input-group-append"
            title="Date To"
            v-model="params.dateTo"
          >

          <div class="input-group-prepend rounded-right">
            <button
              type="submit"
              class="input-group-text input-group-append"
            >
              <i class="fas fa-search" />
            </button>
          </div>
        </form>
      </div>

      <div class="col col-sm-1 text-right offset-2 pt-2 pr-0">
        <label
          for="perPage"
          class="col-form form-label font-weight-bolder text-right"
        >
          <strong>Show:</strong>
        </label>
      </div>
      <div class="col col-sm-2">
        <select
          class="form-control form-control-xs"
          id="perPage"
          v-model="params.perPage"
          @change="searchSchedule"
        >
          <option
            v-for="page in allowedPages"
            :key="page"
            :value="page"
          >
            {{ page }} Records
          </option>
        </select>
      </div>
    </div>

    <table class="table table-hover table-bordered">
      <thead>
        <tr class="table-header">
          <th class="col-index p-1">
            #
          </th>
          <th class="p-1">
            Training Course
          </th>
          <th class="p-1">
            Date
          </th>
          <th class="col-actions p-1">
            Time
          </th>
          <th class="col-actions p-1">
            Venue
          </th>
          <th class="col-actions p-1">
            Scheduled At
          </th>
          <th class="col-actions-sm p-1">
            Max Slot
          </th>
          <th class="col-actions-sm p-1">
            Status
          </th>
          <th class="p-1">
            Actions
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(schedule, index) in trainingScheduleList"
          :key="schedule.id"
        >
          <td class="p-1 align-middle">
            {{ indexNumber(index) }}
          </td>
          <!--                <td>{{ schedule.id }}</td>-->
          <td class="p-1 align-middle">
            {{ schedule.training_course.name }}
          </td>
          <td class="p-1 align-middle">
            {{ schedule.date_from | moment('DD MMM YY') }} -
            {{ schedule.date_to | moment('DD MMM YY') }}
          </td>
          <td class="p-1 align-middle">
            {{ schedule.time_from | parseTime }} -
            {{ schedule.time_to | parseTime }}
          </td>
          <td
            class="p-1 align-middle"
            :title="schedule.training_center.address"
          >
            <div class="text-elipsis">
              {{ schedule.training_center.address }}
            </div>
          </td>
          <td class="p-1 align-middle">
            {{ schedule.created_at | moment('DD MMM YY') }}
          </td>
          <td class="p-1 align-middle">
            {{ schedule.max_slot }}
          </td>
          <td class="p-1 align-middle">
            {{ schedule.status | setStatus }}
          </td>
          <td class="p-1 align-middle text-center">
            <router-link
              :to="'trainingSchedule/' + schedule.id"
              tag="a"
              class="btn btn-sm btn-xs btn-outline-info mr-1 font-weight-bolder"
            >
              <span><i class="fas fa-eye" /></span>
              VIEW
            </router-link>
          </td>
        </tr>
      </tbody>
    </table>

    <nav aria-label="...">
      <ul class="pagination">
        <li
          class="page-item"
          :class="{ disabled: params.currentPage < 1 }"
        >
          <button
            class="page-link"
            @click="paginate(params.currentPage - 1)"
          >
            Previous
          </button>
        </li>

        <li
          class="page-item"
          v-for="(page, index) in pages"
          :key="page"
          :class="{ active: index === params.currentPage }"
        >
          <button
            class="page-link"
            @click="paginate(index)"
          >
            {{ index + 1 }}
          </button>
        </li>

        <li
          class="page-item"
          :class="{ disabled: (params.currentPage + 1) * params.perPage > count }"
        >
          <button
            class="page-link"
            @click="paginate(params.currentPage + 1)"
          >
            Next
          </button>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>

    import { mapGetters, mapActions } from 'vuex'
    import { formMixins } from "../../mixins/formMixins";

    export default {
        mixins: [ formMixins ],
        name: "TrainingScheduleList",
        data() {
            return {
                params: {
                    course: '',
                    dateFrom: '',
                    dateTo: '',
                    perPage: 10,
                    currentPage: 0
                },
                allowedPages: [10, 20, 50, 100, 200],
                count: 0,
            }
        },
        methods: {
            ...mapActions([ 'getTrainingScheduleList' ]),
            async searchSchedule() {
                this.count = await this.getTrainingScheduleList(this.params);
            },
            paginate(page) {
                this.params.currentPage = page;
                this.searchSchedule();
            },
            indexNumber(index) {
                return index + (this.params.perPage * this.params.currentPage) + 1;
            }
        },
        computed: {
            ...mapGetters([ 'trainingScheduleList' ]),
            pages() {
                let pages = [];
                for(let i=0; i<this.count; i+=this.params.perPage) {
                    pages.push(i);
                }
                return pages;
            }
        },
        async created() {
            this.searchSchedule();
        }
    }
</script>

<style scoped>

</style>
